import { ApiGetRequest, ApiPostRequest } from '../api';
import { Apiv2PostRequest } from '../api-v2';

export const state = {
  currentUser: null,
};

export const mutations = {
  SET_CURRENT_USER(state, newValue) {
    state.currentUser = newValue;
    saveState('amanah', newValue);
  },
};

export const getters = {
  // Whether the user is currently logged in.
  loggedIn(state) {
    return !!state.currentUser;
  },
};

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  // eslint-disable-next-line no-unused-vars
  init({ dispatch }) {
    dispatch('validate');
  },

  // Logs in the current user.
  async logIn({ commit }, { user_name, password }) {
    let result = await ApiPostRequest('auth/login', {
      user_name,
      password,
    });

    if (!result.error) {
      let response_object = result.data.object;

      commit('SET_CURRENT_USER', {
        access_token: response_object.access_token,
        expired_token: response_object.expired_token,
        expired_time: response_object.expired_time,
      });
      return true;
    } else {
      return false;
    }
  },

  // get user info
  async getUserInfo() {
    let result = await ApiGetRequest('auth/user-info');
    if (!result.error) {
      return result.data.object;
    } else {
      return null;
    }
  },

  // Logs in principle the current user.
  async logInPrinciple({ commit }, { email, password }) {
    let result = await Apiv2PostRequest('auth/login', {
      email,
      password,
    });

    if (!result.error) {
      commit('SET_CURRENT_USER', result.data.object);
      return true;
    } else {
      return false;
    }
  },

  // Logs out the current user.
  async logOut({ commit }) {
    let result = await ApiPostRequest('auth/logout');

    if (!result.error) {
      commit('SET_CURRENT_USER', null);
      return true;
    } else {
      return false;
    }
  },

  // register the user
  register({ dispatch, getters }) {
    if (getters.loggedIn) return dispatch('validate');

    // return getFirebaseBackend()
    //   .registerUser(email, password)
    //   .then((response) => {
    //     const user = response;
    //     commit('SET_CURRENT_USER', user);
    //     return user;
    //   });
  },

  // register the user
  // eslint-disable-next-line no-unused-vars
  async resetPassword({ commit }, { email }) {
    let result = await ApiPostRequest('auth/forgot-password', {
      email,
    });

    if (result.data.status === 'success') {
      return result.data.object;
    } else {
      return false;
    }
  },

  // Validates the current user's token and refreshes it
  // with new data from the API.
  // eslint-disable-next-line no-unused-vars
  validate({ state }) {
    if (!state.currentUser) return Promise.resolve(null);
    // const user = getFirebaseBackend().getAuthenticatedUser();
    // commit('SET_CURRENT_USER', user);
    // return user;
  },
};

// ===
// Private helpers
// ===

function saveState(key, state) {
  window.localStorage.setItem(key, JSON.stringify(state));
}
